import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useParams, useLocation } from 'react-router-dom'
import { MuiButton, MuiButtons, TourGuide, CustomTooltip } from '../../components'
import ProjectsService from '../../services/projects.service'
import { useGlobalStore } from '../../store'

import { Footer, Sidebar, SideNavSection, Topbar } from '../components'

import { getObjectAsArray, getLogData, timeStampToDate, fakeDelay } from '../../util'
import { IconHamburderMenu, IconMinimize, IconMaximize } from '../../assets/images/iconsV2'

import {
  MainContainer,
  MiddleContainer,
  RightSideContainer,
  Container,
  HeroSection,
  NavigationBarContainer,
  BoldText,
  OptionTitle,
  // TabOuterWrapper,
  ContentSection,
} from './style'
import { IS_SCREEN_BELOW_1366, IS_SCREEN_BELOW_1180 } from '../../constants'

const PostLoginReportsV2 = ({
  children,
  pageTitle,
  pageSubTitle,
  activePage = '',
  actions,
  onChange,
  page,
}) => {
  const [headerData, setHeaderData] = useState({})
  const [selectedLink, setSelectedLink] = useState({})
  const [showLhsMenu, setShowLhsMenu] = useState(false)
  const { pathname } = useLocation()
  const { id } = useParams()
  const { setProjectIdValue, setFullScreen, isFullScreen, isTourGuideActive, setResizeWidth } = useGlobalStore()
  const [isBelow1366 , setIsBelow1366] = useState(IS_SCREEN_BELOW_1366());
  // const [isBelow1280, setIsBelow1280] = useState(IS_SCREEN_BELOW_1280());
  const [headerHamburgerActive , setHeaderHamburgerActive] = useState(false);

  const getHeaderInfo = () => {

    const projectIdValueTemp = getLogData('GetStudies', 'GetStudies', {}, { StudyId: id })?.[0]
    if(projectIdValueTemp && projectIdValueTemp?.ProjectId){
      ProjectsService.projectsDetailApi({ projectId: projectIdValueTemp.ProjectId }, true)
        .then(async(resp) => {
          const obj = getObjectAsArray(resp).find(f => f.StudyId === id)

          const headerLogData = obj.ProjectId
            ? getLogData('GetProjects', 'GetProjects', {}, { ProjectId: obj.ProjectId })[0]
            : {}

          obj['IsAskIAForStudy'] = !!obj?.AskIA || !!obj?.IsAskIAEnabled
          obj['IsSnapshotForStudy'] = !!obj?.Snapshot || !!obj?.IsSnapshotEnabled

          const getImgData = async (selector) => {
            const originalImg = document.querySelector(selector);
            if (!originalImg) return null;

            // 1. Get current rendered size
            const width = originalImg.clientWidth;
            const height = originalImg.clientHeight;

            // 2. Create a NEW image object to handle CORS properly
            // This is the "Magic Fix" for the canvas being tainted
            const img = new Image();
            img.crossOrigin = "anonymous"; 
            
            try {
              // Wrap loading in a promise
              await new Promise((resolve, reject) => {
                img.onload = resolve;
                img.onerror = () => reject(new Error("Failed to load image with CORS."));
                img.src = originalImg.src; 
              });

              // 3. Setup Canvas
              const canvas = document.createElement("canvas");
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext("2d");

              ctx.drawImage(img, 0, 0, width, height);

              const obj = {
                base64: canvas.toDataURL("image/png"),
                width: width,
                height: height
              };

              return obj;
              
            } catch (e) {
              console.error("CORS or Canvas Error:", e.message);
              
              // FALLBACK: If Canvas still fails, use the Fetch method which is more reliable for CORS
              console.log("Attempting Fetch Fallback...");
              try {
                const response = await fetch(originalImg.src);
                const blob = await response.blob();
                const base64 = await new Promise((resolve) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result);
                  reader.readAsDataURL(blob);
                });
                return { base64, width, height };
              } catch (fetchErr) {
                console.error("Fetch fallback failed as well:", fetchErr);
                return null;
              }
            }
          };

          obj['logoBase64'] = await getImgData('.desktopMenu img')
          setProjectIdValue(obj)

          const headerObj = {
            studyId: obj.StudyId,
            breadCrumb: headerLogData.ProjectType,
            title: `${headerLogData.BrandName || headerLogData.CategoryName} ${headerLogData.ProjectType}`,
            subTitle: `${headerLogData.MarketName} | ${obj.Period}`,
            lastUpdated: timeStampToDate(obj.ModifiedDate),
            studyTitle: `${headerLogData.BrandName || headerLogData.CategoryName}`,
            studySubTitle: `${headerLogData.ProjectType}, ${headerLogData.MarketName}`,
          }
          setHeaderData(headerObj)
          setProjectIdValue(obj)
        })
        .catch(() => {})
    }
    /*
    const projectIdValue = getLogData('GetStudies', 'GetStudies', {}, { StudyId: id })[0]

    const headerLogData = projectIdValue.ProjectId
      ? getLogData('GetProjects', 'GetProjects', {}, { ProjectId: projectIdValue.ProjectId })[0]
      : {}

    projectIdValue['IsAskIAForStudy'] = !!projectIdValue?.AskIA || !!projectIdValue?.IsAskIAEnabled
    projectIdValue['IsSnapshotForStudy'] = !!projectIdValue?.Snapshot || !!projectIdValue?.IsSnapshotEnabled
    setProjectIdValue(projectIdValue)

    const headerObj = {
      studyId: projectIdValue.StudyId,
      breadCrumb: headerLogData.ProjectType,
      title: `${headerLogData.BrandName || headerLogData.CategoryName} ${headerLogData.ProjectType}`,
      subTitle: `${headerLogData.MarketName} | ${projectIdValue.Period}`,
      lastUpdated: timeStampToDate(projectIdValue.ModifiedDate),
      studyTitle: `${headerLogData.BrandName || headerLogData.CategoryName}`,
      studySubTitle: `${headerLogData.ProjectType}, ${headerLogData.MarketName}`,
    }
    setHeaderData(headerObj)
    */
  }

  const onChangeLhs = (param) => {
    setSelectedLink(param.selectedTab)
    onChange({ ...param, studyId: id })
  }

  const handleScroll = () => {}

  useEffect(() => {
    getHeaderInfo()
  }, [pathname])

  useEffect(() => {
    // setIsBelow1280(IS_SCREEN_BELOW_1280());
    setIsBelow1366(IS_SCREEN_BELOW_1366());
  }, [])

    useEffect(() => {
      function resizeHandler() {
        setResizeWidth(window.innerWidth)
      }

      window.addEventListener('resize', resizeHandler)
      // return () => window.removeEventListener('resize', resizeHandler)
    }, [])
  
  return (
    <>
      <MainContainer
        className={`${isFullScreen ? 'fullScreen' : ''} ${isBelow1366 ? 'md-screen' : ''} ${showLhsMenu ? 'showLhsMenu' : ''} ${IS_SCREEN_BELOW_1180() ? 'sm-screen' : ''}`}
      >
        {isTourGuideActive && <TourGuide type='postLoginReports' />}

        <Sidebar activePage={activePage} page={page} />
        <RightSideContainer>
          <Topbar
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            studyTitle={headerData.studyTitle}
            studySubTitle={headerData.studySubTitle}
            actions={actions}
            setShowLhsMenu={setShowLhsMenu}
            showHamburgerMenu={isBelow1366}
            setHeaderHamburgerActive={setHeaderHamburgerActive}
            headerHamburgerActive={headerHamburgerActive}
          />
          <HeroSection className='contentSection'>
            <SideNavSection headerHamburgerActive={headerHamburgerActive} onChange={onChangeLhs} hideLhsMenu={() => setShowLhsMenu(false)} />

            <MiddleContainer>
              <NavigationBarContainer>
                {/* {isFullScreen && <MuiButtons buttonType='hamburderMenu' onClick={() => setShowLhsMenu(true)} className='hamburderMenu' />} */}
                {/* Just add a condition of below 1280 to full screen button */}
                {isFullScreen && (
                  <MuiButton
                    startIcon={<IconHamburderMenu />}
                    color='light'
                    size='small'
                    variant='text'
                    onClick={() => setShowLhsMenu(true)}
                    className='hamburderMenu'
                  />
                )}
                {selectedLink?.TabName && <BoldText>{selectedLink.TabName}</BoldText>}
                <OptionTitle data-tabname={selectedLink?.TabName}  id='breadCrumbLevel2'></OptionTitle>
                <div className={`fullScreenIcon ${isFullScreen ? 'screenFull' : 'n-fullScreen'}`}>
                {isFullScreen ? (
                  <CustomTooltip title='Exit Fullscreen' valign='bottom' align='right'><MuiButton
                    startIcon={<IconMinimize />}
                    color="light"
                    variant="outlined"
                    onClick={() => setFullScreen(false)}
                  /></CustomTooltip>
                ) : (
                  <CustomTooltip title='Fullscreen' valign='bottom' align='right'><MuiButton
                    startIcon={<IconMaximize />}
                    color="light"
                    variant="outlined"
                    onClick={() => setFullScreen(true)}
                    /></CustomTooltip>
                  )}
                  </div>
              </NavigationBarContainer>
              {/* <TabOuterWrapper id='tabLevel3' className='tab-sticky'></TabOuterWrapper> */}
              <Container id='reportsContentSection' className='rhsContent' onScroll={handleScroll}>
                <ContentSection>{children}</ContentSection>
                <Footer />
              </Container>
            </MiddleContainer>
          </HeroSection>
        </RightSideContainer>
      </MainContainer>
    </>
  )
}

PostLoginReportsV2.propTypes = {
  children: PropTypes.node,
  pageTitle: PropTypes.string,
  pageSubTitle: PropTypes.string,
  activePage: PropTypes.string,
  actions: PropTypes.array,
  onChange: PropTypes.func,
  page: PropTypes.string,
}

export default PostLoginReportsV2
